import React, { useEffect } from 'react';
// import { Provider } from 'react-redux';
import { HashRouter as Router, Route, Switch, } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
// import { UseWalletProvider } from 'use-wallet';
import Parse from 'parse'

// import BanksProvider from './contexts/Banks';
// import BasisCashProvider from './contexts/BasisCashProvider';
import ModalsProvider from './contexts/Modals';
import DrawerProvider from './contexts/Drawers';

import Home from './views/Home'; 
import ArticlesProvider from './contexts/Articles'
// import Bond from './views/Bond';

import { StoreProvider as Provider} from './state/store-provider'
import store from './state';
import theme from './theme';
import ImagesProvider from './contexts/Images';

import RefreshCollectContent from './contexts/RefreshCollectContent';
import {Helmet} from 'react-helmet'
import moment from 'moment'//在原有的基础上加上下面三行代码
import 'moment/locale/zh-cn' 
// import PlanWinGo from './views/PlanWinGo1';
import PlanWinGoDetail from './views/PlanDetail';
import LanguageSet from './views/LanguageSet';
import Draw from './views/Draw';
import Webpage from './views/WebPage';
import { useInitLanguage } from './views/LanguageSet/LanguageSet';
moment.locale('zh-cn') 
// import Parse from 'parse'

Parse.initialize('app')
Parse.serverURL = 'https://api.wingolottery.cc/parse'

const App: React.FC = () => {
  useInitLanguage()
  return (
    <Providers>
      
      <Helmet>
        <link rel="shortcut icon" href="./scys.ico" type="image/x-icon"/>
      </Helmet>
      <Router>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/wingo">
            <Draw />
          </Route>
          <Route path="/wingo_30s">
            <Draw />
          </Route>
          <Route path="/wingo_1m">
            <Draw />
          </Route>
          <Route path="/wingo_3m">
            <Draw />
          </Route>
          <Route path="/wingo_5m">
            <Draw />
          </Route>
          <Route path="/k3_1m">
            <Draw />
          </Route>
          <Route path="/k3_3m">
            <Draw />
          </Route>
          <Route path="/k3_5m">
            <Draw />
          </Route>
          <Route path="/k3_10m">
            <Draw />
          </Route>
          <Route path="/5d_1m">
            <Draw />
          </Route>
          <Route path="/5d_3m">
            <Draw />
          </Route>
          <Route path="/5d_5m">
            <Draw />
          </Route>
          <Route path="/5d_10m">
            <Draw />
          </Route>
          {/* <Route path="/plan_wingo/:typeId">
            <PlanWinGo />
          </Route> */}
          <Route path="/plan_detail/:params">
            <PlanWinGoDetail />
          </Route>
          <Route path="/language">
            <LanguageSet />
          </Route>
          <Route path="/article/:id">
            <Webpage />
          </Route>
          <Route path="/trxwingo_1m">
            <Draw />
          </Route>
          <Route path="/trxwingo_3m">
            <Draw />
          </Route>
          <Route path="/trxwingo_5m">
            <Draw />
          </Route>
          <Route path="/trxwingo_10m">
            <Draw />
          </Route>
          
        </Switch>
      </Router> 
    </Providers>
  );
};

const Providers: React.FC = ({ children }) => {
  
  return (
    <ThemeProvider theme={theme}>    
      <ArticlesProvider >
        <Provider value={store.TodoList}>
          {/* <Updaters /> */} 
          <RefreshCollectContent>
            <DrawerProvider> 
              <ImagesProvider>
                  <ModalsProvider>
                      <>
                        {/* <Popups /> */}
                        {children}
                      </> 
                  </ModalsProvider> 
              </ImagesProvider>
            </DrawerProvider>
          </RefreshCollectContent>
        </Provider> 
      </ArticlesProvider>
    </ThemeProvider>
  );
};

export default App;
